import produce from 'immer';

import {
  USERS_RECEIVED,
  USERS_INVITE_SENT,
  SESSION_AUTH_INVALID,
  USER_INVITES_RECEIVED
} from 'constants/actions';

export var INITIAL_STATE = {
  items: [],
  invitations: [],
  lastInvite: Date.now()
};

export const users = produce((draft, action) => {
  switch (action.type) {
    case SESSION_AUTH_INVALID:
      draft = INITIAL_STATE;
      return draft;

    case USERS_RECEIVED:
      draft.items = action.value;
      return draft;
  
    case USERS_INVITE_SENT: 
      draft.lastInvite = Date.now();
      return draft;

    case USER_INVITES_RECEIVED:
      draft.invitations = action.value;
      return draft;

    default:
      return draft;
  }
}, INITIAL_STATE);

export default users;
